import React from 'react';
import { Button } from '@material-ui/core';
// import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import NotificationActions from 'redux/reducers/notification_reducer/actions';
import useStyles from './styles';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { Roles } from 'config';
import useQuery from 'custom_hooks/useQuery';

interface IProps {
  rowIndex: number;
  data: Array<any>;
  dataid: string | number;
}

export default function ActionsBlock({ rowIndex, data, dataid }: IProps) {
  // const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const ROLE = AuthSelectors.useSelectUserRole();
  const query = useQuery();

  const handleClick = () => {
    if (!data[rowIndex].is_read && ROLE !== Roles.Admin) {
      dispatch(
        NotificationActions.setNotificationViewAction({
          notificationId: data[rowIndex].notification_id,
          onSuccess: () => {
            const notificationState = getState(ReducerKeys.NOTIFICATION_REDUCER)
              .NotificationList.data;
            const pagingInfo = notificationState.paging;
            const sortingInfo = notificationState.sorting;
            dispatch(
              NotificationActions.fetchNotificationListAction({
                sortField: sortingInfo.sortField,
                page: pagingInfo.page,
                pageSize: pagingInfo.pageSize,
                order: sortingInfo.order,
                vatNumber: query.get('notificationVatNumber'),
                notificationType: query.get('notificationType'),
                notificationDateFrom: query.get('notificationDateFrom'),
                notificationDateTo: query.get('notificationDateTo'),
              })
              // NotificationActions.fetchNotificationListAction({
              //   sortField:
              //     NotificationTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
              //   page: NotificationTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
              //   pageSize:
              //     NotificationTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
              //   order: NotificationTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
              // })
            );
            dispatch(NotificationActions.fetchUnreadNotificationCountAction());
          },
        })
      );
    }
    let header = data[rowIndex].notification_title;
    let body = data[rowIndex].notification_message;
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_NOTIFICATION_VIEW,
        params: { header, body },
      })
    );
  };

  return (
    <React.Fragment>
      <Button
        // variant="outlined"
        // className={classes.viewButton}
        onClick={() => handleClick()}
      >
        View
      </Button>
    </React.Fragment>
  );
}
